module.exports = __webpack_public_path__ + "assets/images/JMDUNFIT2000.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/JMDUNFIT2000.png
// module id = 1404
// module chunks = 1